var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarthi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.7 377.7",
    style: {
      enableBackground: "new 0 0 407.7 377.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#80CEF4;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#75B626;}\r\n\t.st5{fill:#565656;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Earthi Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Safe_Area",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 186.4,
    cy: 347.9,
    r: 29.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 186.5,
    cy: 330.8,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.1,337h2.8c0.4,0,0.8,0.3,0.8,0.8v26.6c0,0.4-0.4,0.8-0.8,0.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-26.6 C184.3,337.3,184.7,337,185.1,337z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 186.4,
    cy: 29.9,
    r: 29.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 186.5,
    cy: 12.8,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.1,19h2.8c0.4,0,0.8,0.3,0.8,0.8v26.6c0,0.4-0.4,0.8-0.8,0.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8V19.7 C184.3,19.3,184.7,19,185.1,19z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 378.1,
    cy: 189.5,
    r: 29.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 378.2,
    cy: 172.4,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M376.8,178.6h2.8c0.4,0,0.8,0.3,0.8,0.8V206c0,0.4-0.4,0.8-0.8,0.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-26.6 C376,179,376.3,178.6,376.8,178.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 29.7,
    cy: 188.2,
    r: 29.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 29.9,
    cy: 171.1,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.4,177.3h2.8c0.4,0,0.8,0.3,0.8,0.8v26.6c0,0.4-0.4,0.8-0.8,0.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-26.6 C27.6,177.6,28,177.3,28.4,177.3z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.6,60.3c-71.3,0-129.1,57.8-129.1,129.1s57.8,129.1,129.1,129.1c71.3,0,129.1-57.8,129.1-129.1 S260.9,60.3,189.6,60.3z M207.7,298.9c-60.5,0-109.5-49-109.5-109.5C98.2,129,147.2,80,207.7,80c60.5,0,109.5,49,109.5,109.5 C317.2,249.9,268.1,298.9,207.7,298.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 318.8,
    cy: 189.5,
    r: 29.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 318.8,
    cy: 172.4,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.4,178.6h2.8c0.4,0,0.8,0.3,0.8,0.8V206c0,0.4-0.4,0.8-0.8,0.8h-2.8c-0.4,0-0.8-0.3-0.8-0.8v-26.6 C316.6,179,316.9,178.6,317.4,178.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M132.5,193.8c-0.7,0-1.3,0.7-1.1,1.4c0.2,1,0.5,2,0.9,2.8c0.6,1.2,1.4,2.3,2.4,3.1c1,0.8,2,1.5,3.2,1.9 c1.2,0.4,2.4,0.7,3.7,0.7c2.1,0,3.8-0.4,5.3-1.2c1.2-0.6,2.3-1.4,3.3-2.3c0.4-0.4,1.1-0.4,1.5,0l1.1,1c0.5,0.4,0.5,1.2,0.1,1.6 c-1.3,1.3-2.7,2.4-4.3,3.2c-1.9,1-4.3,1.5-7.1,1.5c-2,0-3.9-0.4-5.7-1.1c-1.8-0.7-3.4-1.8-4.7-3.2c-1.3-1.4-2.4-3-3.2-4.9 c-0.8-1.9-1.2-4-1.2-6.3c0-2.1,0.4-4.2,1.1-6.1c0.7-1.9,1.7-3.5,3-4.9c1.3-1.4,2.8-2.5,4.5-3.3c1.7-0.8,3.6-1.2,5.7-1.2 c2.2,0,4.1,0.4,5.9,1.2c1.7,0.8,3.2,1.9,4.4,3.4c1.2,1.4,2.1,3.1,2.7,5c0.6,1.9,0.9,4,0.9,6.2c0,0.2,0,0.4,0,0.7 c0,0.3,0,0.5-0.1,0.9H132.5z M149,190.1c0.7,0,1.2-0.6,1.1-1.3c-0.2-0.9-0.4-1.7-0.7-2.5c-0.5-1.2-1.1-2.3-1.9-3.2 c-0.8-0.9-1.7-1.6-2.9-2.2c-1.1-0.5-2.4-0.8-3.9-0.8c-1.3,0-2.5,0.2-3.6,0.7c-1.1,0.5-2.1,1.2-2.9,2.1c-0.8,0.9-1.5,2-2.1,3.2 c-0.4,0.8-0.6,1.7-0.8,2.6c-0.2,0.7,0.4,1.4,1.1,1.4H149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M173.7,207.4c-1.4,0-2.7-0.2-4.1-0.6c-1.3-0.4-2.5-1-3.6-1.8c-1-0.8-1.9-1.8-2.5-2.9c-0.6-1.2-0.9-2.5-0.9-4 v-0.1c0-1.6,0.3-3,0.9-4.2c0.6-1.2,1.5-2.2,2.6-3c1.1-0.8,2.5-1.4,4-1.8c1.6-0.4,3.3-0.6,5.1-0.6c1.9,0,3.6,0.1,5,0.3 c1.4,0.2,2.8,0.5,4.1,0.9v-0.9c0-2.6-0.8-4.6-2.3-6c-1.5-1.4-3.7-2-6.5-2c-1.8,0-3.4,0.2-4.8,0.6c-1.1,0.3-2.1,0.6-3.1,1.1 c-0.6,0.3-1.3,0-1.5-0.6l-0.5-1.5c-0.2-0.6,0.1-1.2,0.6-1.4c1.3-0.6,2.7-1.1,4-1.4c1.7-0.5,3.6-0.7,5.8-0.7c4.2,0,7.4,1.1,9.6,3.3 c2.1,2.1,3.1,5,3.1,8.7v17c0,0.6-0.5,1.1-1.1,1.1h-2.1c-0.6,0-1.1-0.5-1.1-1.1v-0.5c0-1-1.1-1.5-1.9-0.9c-0.7,0.6-1.5,1.1-2.3,1.6 C178.5,206.9,176.3,207.4,173.7,207.4z M174.6,203.8c1.4,0,2.7-0.2,3.8-0.6c1.2-0.4,2.2-0.9,3.1-1.6c0.9-0.7,1.6-1.5,2.1-2.5 c0.5-1,0.8-2,0.8-3.2V194c0-0.5-0.3-1-0.8-1.1c-0.9-0.2-1.9-0.4-2.9-0.6c-1.4-0.3-3-0.4-4.9-0.4c-2.7,0-4.9,0.5-6.4,1.6 c-1.5,1.1-2.3,2.5-2.3,4.3v0.1c0,0.9,0.2,1.7,0.6,2.5c0.4,0.7,0.9,1.4,1.6,1.9c0.7,0.5,1.5,0.9,2.4,1.1 C172.6,203.7,173.6,203.8,174.6,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.6,177.1h2.2c0.6,0,1.1,0.5,1.1,1.1v6.6c0.5-1.2,1.2-2.4,2-3.4s1.7-1.9,2.8-2.7c1-0.7,2.2-1.3,3.4-1.7 c0.9-0.3,1.8-0.4,2.7-0.5c0.7,0,1.2,0.5,1.2,1.1v3.6h-0.3c-1.6,0-3.1,0.3-4.6,0.9c-1.4,0.6-2.7,1.4-3.8,2.6 c-1.1,1.2-1.9,2.6-2.5,4.3c-0.6,1.7-0.9,3.7-0.9,5.9v10.7c0,0.6-0.5,1.1-1.1,1.1h-2.2c-0.6,0-1.1-0.5-1.1-1.1v-27.5 C200.4,177.6,200.9,177.1,201.6,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.9,207.3c-1.2,0-2.3-0.2-3.3-0.5s-1.9-0.8-2.7-1.5c-0.7-0.7-1.3-1.5-1.8-2.6s-0.6-2.4-0.6-3.9v-16.8 c0-0.6-0.5-1.1-1.1-1.1h-1.9c-0.6,0-1.1-0.5-1.1-1.1v-1.6c0-0.6,0.5-1.1,1.1-1.1h1.9c0.6,0,1.1-0.5,1.1-1.1v-6.7 c0-0.6,0.5-1.1,1.1-1.1h2.2c0.6,0,1.1,0.5,1.1,1.1v6.7c0,0.6,0.5,1.1,1.1,1.1h7.2c0.6,0,1.1,0.5,1.1,1.1v1.6 c0,0.6-0.5,1.1-1.1,1.1h-7.2c-0.6,0-1.1,0.5-1.1,1.1v16.2c0,1.8,0.5,3.1,1.4,3.8c0.9,0.7,2.1,1.1,3.6,1.1c0.8,0,1.5-0.1,2.2-0.2 c0.7-0.1,1.4-0.4,2.2-0.8v3.1c0,0.4-0.2,0.8-0.6,1c-0.6,0.3-1.2,0.5-1.8,0.6C238,207.2,237,207.3,235.9,207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.7,164.8h2.2c0.6,0,1.1,0.5,1.1,1.1v13c0,1,1.2,1.5,1.9,0.8c0.6-0.6,1.2-1.1,2-1.6 c1.6-1.1,3.7-1.7,6.3-1.7c1.8,0,3.4,0.3,4.8,0.9c1.4,0.6,2.6,1.4,3.6,2.4s1.7,2.3,2.2,3.8c0.5,1.5,0.8,3.1,0.8,4.8v17.3 c0,0.6-0.5,1.1-1.1,1.1h-2.2c-0.6,0-1.1-0.5-1.1-1.1v-16.2c0-2.8-0.7-4.9-2.1-6.5c-1.4-1.6-3.4-2.4-6.1-2.4 c-1.3,0-2.4,0.2-3.5,0.7c-1.1,0.4-2,1.1-2.8,1.9c-0.8,0.8-1.4,1.8-1.9,3c-0.4,1.1-0.7,2.4-0.7,3.8v15.8c0,0.6-0.5,1.1-1.1,1.1 h-2.2c-0.6,0-1.1-0.5-1.1-1.1V166C251.5,165.3,252,164.8,252.7,164.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthi);
export default __webpack_public_path__ + "static/media/earthi.fab8efc18b9e53c249e5f976df79ee9f.svg";
export { ForwardRef as ReactComponent };